const DATABASE = 'zoea-worship';
const STORE = 'documents';

const openDatabase = (): Promise<IDBDatabase> => new Promise((resolve, reject) => {
  const request = indexedDB.open(DATABASE, 1);
  request.onupgradeneeded = () => request.result.createObjectStore(STORE);
  request.onsuccess = () => resolve(request.result);
  request.onerror = () => reject(request.error);
});

export const cacheWorshipData = async (key: string, value: unknown): Promise<void> => {
  if (!('indexedDB' in window)) return;
  const database = await openDatabase();
  await new Promise<void>((resolve, reject) => {
    const transaction = database.transaction(STORE, 'readwrite');
    transaction.objectStore(STORE).put({ value, cachedAt: new Date().toISOString() }, key);
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
  });
  database.close();
};

export const getCachedWorshipData = async <T>(key: string): Promise<T | null> => {
  if (!('indexedDB' in window)) return null;
  const database = await openDatabase();
  return new Promise<T | null>((resolve, reject) => {
    const request = database.transaction(STORE, 'readonly').objectStore(STORE).get(key);
    request.onsuccess = () => { database.close(); resolve(request.result?.value ?? null); };
    request.onerror = () => { database.close(); reject(request.error); };
  });
};
